const scrollPhotos = () => {
    const page = document.querySelector('.product-page');
    const photos = document.querySelector('#photos');
    const main = document.querySelector('#main');
    if (!page && !photos && !main) {
        return false;
    }
    if (page.clientWidth < 960) {
        return false;
    }
    ;
    window.addEventListener('scroll', function () {
        const H_main = main.getBoundingClientRect().height;
        const H_photos = photos.getBoundingClientRect().height;
        const T_main = main.getBoundingClientRect().top;
        if (T_main < 0) {
            if (H_main > H_photos && (H_photos + (-T_main)) < H_main) {
                photos.style.marginTop = (-T_main).toString() + 'px';
            }
        }
    });
};
export default scrollPhotos;
